import {
    EI_CANDIDATE_RENDERER_REGISTRY,
    EiCandidateRendererEntry
} from '../../feature-integration/ei/interface/ei-candidate-renderer-registry';
import {
    CrEiCandidateRendererComponent
} from './component/protected-components/cr-ei-candidate-renderer/cr-ei-candidate-renderer.component';

export const CR_EI_RENDERER_PROVIDER = [{
    provide: EI_CANDIDATE_RENDERER_REGISTRY,
    useValue: [
        ['cr.Customer', {component: CrEiCandidateRendererComponent}],
    ] as EiCandidateRendererEntry[],
    multi: true
}];
